import { render, staticRenderFns } from "./groupOrder.vue?vue&type=template&id=16fd41db&scoped=true"
import script from "./groupOrder.vue?vue&type=script&lang=js"
export * from "./groupOrder.vue?vue&type=script&lang=js"
import style0 from "./groupOrder.vue?vue&type=style&index=0&id=16fd41db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd41db",
  null
  
)

export default component.exports